import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Popover, Space, Tag, Typography } from "antd";
import type { ValidationProfileResponse } from "../../types/validation.types";

interface ValidationLevelCardProps {
  summary: ValidationProfileResponse;
  onUpgrade?: () => void;
}

const levelLabel: Record<ValidationProfileResponse["validationLevel"], string> = {
  LEVEL_1: "Nível 1 (Básico)",
  LEVEL_2: "Nível 2 (Telefone)",
  LEVEL_3: "Nível 3 (Documento)",
};

const guidanceContent = (
  <Space direction="vertical" size={6} style={{ maxWidth: 320 }}>
    <Typography.Text strong>Nível 1</Typography.Text>
    <Typography.Text type="secondary">
      Cadastro básico ativo. Permite participação em pesquisas sem exigência adicional.
    </Typography.Text>
    <Typography.Text strong>Nível 2</Typography.Text>
    <Typography.Text type="secondary">
      Exige validação de telefone. Libera pesquisas com requisito intermediário de confiança.
    </Typography.Text>
    <Typography.Text strong>Nível 3</Typography.Text>
    <Typography.Text type="secondary">
      Exige validação documental. Em breve.
    </Typography.Text>
  </Space>
);

export function ValidationLevelCard({ summary, onUpgrade }: ValidationLevelCardProps) {
  const canUpgrade = summary.validationLevel === "LEVEL_1";

  return (
    <div>
      <Typography.Text strong style={{ display: 'block', marginBottom: 8 }}>Nível de validação</Typography.Text>
      <Space align="center" wrap>
        <Tag color="blue">{levelLabel[summary.validationLevel]}</Tag>
        <Popover content={guidanceContent} title="Como funcionam os níveis" trigger="click">
          <Button icon={<InfoCircleOutlined />} size="small" type="text" />
        </Popover>
        {canUpgrade && (
          <Button size="small" type="primary" onClick={onUpgrade}>
            Elevar para nível 2
          </Button>
        )}
      </Space>
    </div>
  );
}

export default ValidationLevelCard;
